import React from 'react';
import withUiBase from './withUiBase';

export function createUiBaseMountAction(kiddieFn, middleFn) {
  class ComponentWithUiBaseMountAction extends React.Component {
    componentDidMount() {
      this.timeoutId = setTimeout(() => {
        if (this.props.uiBase === 'kiddie') {
          kiddieFn();
        } else if (this.props.uiBase === 'middle') {
          middleFn();
        }
      }, this.props.delay);
    }

    componentWillUnmount() {
      clearTimeout(this.timeoutId);
    }

    render() {
      return null;
    }
  }

  ComponentWithUiBaseMountAction.defaultProps = {
    delay: 0,
  };

  return withUiBase(ComponentWithUiBaseMountAction);
}



// WEBPACK FOOTER //
// ./src/app/ui/config/createUiBaseMountAction.js